import React from 'react';

import { Alert, Typography } from '@mui/material';

import { type ExperimentalFeatureKey, experimentalFeatures } from '@luxuryescapes/contract-svc-promo';

import isProd from '~/utils/isProd';

interface Props {
  featureKey: ExperimentalFeatureKey;
}

export default function ExperimentalFeatureNotice({ featureKey }: Props) {
  const feature = experimentalFeatures.find((item) => item.key === featureKey);

  if (!feature) {
    return null;
  }

  const isUnavailableTestFeature = feature.isOnlyTest && isProd();

  return (
    <Alert severity={isUnavailableTestFeature ? 'warning' : 'info'} variant="outlined" sx={{ py: 0 }}>
      <Typography variant="body2">
        Experimental feature: {feature.experimentalStatus}. {feature.currentStatusHeadline}.
      </Typography>
    </Alert>
  );
}
